var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMicrophoneOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A390CD39-90C1-452D-923F-FFFEC6DDBB17") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "In-a-Call-+-UI-Kit",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "C_Waiting-Room_V3B-leave",
    transform: "translate(-738.000000, -445.000000)",
    fill: "#DE5959",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "video",
    transform: "translate(413.000000, 162.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "microphone",
    transform: "translate(316.000000, 274.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(9.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.0991413,15.7931304 C9.70618027,15.7931304 10.1982826,16.2852327 10.1982826,16.8922717 C10.1982826,20.5345055 13.1508965,23.4871194 16.7931304,23.4871194 C17.6478699,23.4871194 18.4646306,23.3245127 19.2141654,23.0285462 L20.8706679,24.6848541 C19.9603538,25.1621638 18.9560973,25.4846393 17.892883,25.6172958 L17.8922717,27.8836846 C17.8922717,28.4907235 17.4001693,28.9828259 16.7931304,28.9828259 C16.1860914,28.9828259 15.6939891,28.4907235 15.6939891,27.8836846 L15.6933778,25.6172958 C11.3561197,25.0761391 8,21.3761372 8,16.8922717 C8,16.2852327 8.49210232,15.7931304 9.0991413,15.7931304 Z M7.3263456,5.10459415 L11.6850195,9.46442674 C12.4928582,7.43469577 14.4754487,6 16.7931304,6 C19.8283252,6 22.2888368,8.4605116 22.2888368,11.4957065 L22.2888368,15.8922717 C22.2888368,17.0729763 21.916501,18.1667173 21.2828404,19.0624835 L22.4708572,20.2492159 C23.0535117,19.2658723 23.3879781,18.1181314 23.3879781,16.8922717 C23.3879781,16.2852327 23.8800805,15.7931304 24.4871194,15.7931304 C25.0941584,15.7931304 25.5862607,16.2852327 25.5862607,16.8922717 C25.5862607,18.7271821 25.0242275,20.4308226 24.0629208,21.8404334 L28.539549,26.3177976 L26.9132034,27.9441432 L5.7,6.73093975 L7.3263456,5.10459415 Z M11.297,15.11 L17.5256861,21.3395805 C17.2860382,21.3715011 17.0415085,21.3879781 16.7931304,21.3879781 C13.7579355,21.3879781 11.2974239,18.9274665 11.2974239,15.8922717 L11.297,15.11 Z M16.7931304,8.19828259 C15.0440254,8.19828259 13.613,9.56014353 13.5025617,11.2813581 L19.6900641,17.4686294 C19.9454333,17.00032 20.0905543,16.4632432 20.0905543,15.8922717 L20.0905543,11.4957065 C20.0905543,9.67458955 18.6142472,8.19828259 16.7931304,8.19828259 Z",
    id: "Combined-Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMicrophoneOff);
export default __webpack_public_path__ + "static/media/icon-microphoneOff.6c3c03a3e6a4eb3375f937e148a09f2d.svg";
export { ForwardRef as ReactComponent };